import { render, staticRenderFns } from "./input_form.vue?vue&type=template&id=ba60b7c4&scoped=true"
import script from "./input_form.vue?vue&type=script&lang=js"
export * from "./input_form.vue?vue&type=script&lang=js"
import style0 from "./input_form.vue?vue&type=style&index=0&id=ba60b7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba60b7c4",
  null
  
)

export default component.exports